export default{
  login:{
    loginTypeTab:{
      loginway:"账号密码登录",
      loginway1:"快捷登录",
    },
    Placeholder:{
      username:"请输入用户名称",
      password:"请输入登录密码",
      mobile:"请输入注册手机号或邮箱",
      valCode:"请输入验证码"
    },
    Button:{
      loginSubBtn:'登录',
      getCode:{
        codeBtnText:"获取验证码",
        reSendcodeBtnText:"重发验证码",
        countdown:"秒后重新发送"
      }
    },
    Checkbox:{
      isRemember:'记住密码',
    },
    loginOtherOpts:{
      haveNoAccuont:"还没账号？",
      href:"快速注册"
    },
    rules:{
      required:{
        username:"请输入用户名",
        password:"请输入密码",
        mobile:"请输入注册手机号",
        valCode:"请输入验证码"
      }
    },
    Message:{
      mobile:'请输入手机号码',
      sendSuccess:"验证码已发送！",
    },
    Alert:{
        error:{
            title:'提示',
            text:'数据请求失败，请重试',
            buttonText:'确定',
        }
    },
  }
  
}